(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["collection-browse"] && !Shopify.designMode) return;
  try {
    class BrowseChipsComponent extends HTMLElement {
    connectedCallback() {
      this.grid = document.querySelector(`[section-id="${this.dataset.targetSection}"]`);
      if (!this.grid) return;

      this.chips = [...this.querySelectorAll('.browse-chip')];
      this.clearButton = this.querySelector('.browse-chips__clear');
      this.message = this.querySelector('.browse-chips__message');
      this.selected = { theme: new Set(), type: new Set() };
      this.loading = null;

      const params = new URLSearchParams(window.location.search);
      for (const [group, key] of [['theme', 'themes'], ['type', 'types']]) {
        (params.get(key) || '')
          .split(',')
          .filter(Boolean)
          .forEach((value) => this.selected[group].add(value));
      }

      this.chips.forEach((chip) => {
        chip.addEventListener('click', () => {
          const set = this.selected[chip.dataset.group];
          set.has(chip.dataset.value) ? set.delete(chip.dataset.value) : set.add(chip.dataset.value);
          this.update();
        });
      });

      this.clearButton.addEventListener('click', () => {
        this.selected.theme.clear();
        this.selected.type.clear();
        this.update();
      });

      // The theme's infinite scroll can append pages we already loaded, so keep one card per product.
      const list = this.grid.querySelector('[ref="grid"]');
      if (list) new MutationObserver(() => this.dedupeCards()).observe(list, { childList: true });

      if (this.selected.theme.size || this.selected.type.size) this.update();
    }

    dedupeCards() {
      const list = this.grid.querySelector('[ref="grid"]');
      if (!list) return;
      const seen = new Set();
      for (const card of list.querySelectorAll(':scope > [ref="cards[]"]')) {
        const link = card.querySelector('a[href*="/products/"]');
        const key = link && link.getAttribute('href').split('?')[0];
        if (!key) continue;
        if (seen.has(key)) card.remove();
        else seen.add(key);
      }
    }

    // Fetch every collection page we don't have yet and append its cards to the grid,
    // so filtering sees the whole collection (the theme otherwise loads 24 at a time).
    loadAllPages() {
      if (this.loading) return this.loading;

      const list = this.grid.querySelector('[ref="grid"]');
      const lastPage = Number(list?.dataset.lastPage || 1);
      const loaded = new Set([...list.querySelectorAll(':scope > [ref="cards[]"]')].map((li) => li.dataset.page));
      const missing = [];
      for (let page = 1; page <= lastPage; page++) if (!loaded.has(String(page))) missing.push(page);

      this.loading = Promise.all(
        missing.map(async (page) => {
          const url = new URL(window.location.href);
          url.searchParams.set('section_id', this.dataset.targetSection.replace(/^shopify-section-/, ''));
          url.searchParams.set('page', page);
          url.hash = '';
          const html = await fetch(url).then((response) => response.text());
          const doc = new DOMParser().parseFromString(html, 'text/html');
          return [page, [...doc.querySelectorAll('[ref="grid"] > [ref="cards[]"]')]];
        })
      )
        .then((pages) => {
          pages.sort((a, b) => a[0] - b[0]);
          const grid = this.grid.querySelector('[ref="grid"]');
          for (const [, cards] of pages) grid.append(...cards.map((card) => document.importNode(card, true)));
        })
        .catch(() => {
          this.loading = null;
        });
      return this.loading;
    }

    async update() {
      const themes = [...this.selected.theme];
      const types = [...this.selected.type];
      const active = themes.length + types.length > 0;

      this.chips.forEach((chip) => {
        const on = this.selected[chip.dataset.group].has(chip.dataset.value);
        chip.classList.toggle('is-active', on);
        chip.setAttribute('aria-pressed', on);
      });
      this.clearButton.hidden = !active;

      const url = new URL(window.location.href);
      url.searchParams.delete('themes');
      url.searchParams.delete('types');
      if (themes.length) url.searchParams.set('themes', themes.join(','));
      if (types.length) url.searchParams.set('types', types.join(','));
      history.replaceState(history.state, '', url);

      if (themes.length) this.grid.dataset.themeFilter = themes.join(',');
      else delete this.grid.dataset.themeFilter;
      if (types.length) this.grid.dataset.typeFilter = types.join(',');
      else delete this.grid.dataset.typeFilter;

      if (active) {
        this.message.textContent = 'Loading…';
        this.message.hidden = false;
        await this.loadAllPages();
      }
      this.applyFilter();
    }

    applyFilter() {
      this.dedupeCards();
      const Category = customElements.get('category-filter-component');
      if (Category) Category.applyFilter(this.grid);

      const visible = this.grid.querySelectorAll('li[data-category]:not([hidden])').length;
      const active = this.selected.theme.size + this.selected.type.size > 0;
      this.message.hidden = !active;
      this.message.textContent = active
        ? visible
          ? `${visible} ${visible === 1 ? 'product' : 'products'}`
          : 'Nothing matches that combination yet. Try removing a chip.'
        : '';
    }
  }

  if (!customElements.get('browse-chips-component')) {
    customElements.define('browse-chips-component', BrowseChipsComponent);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["collection-category-filter"] && !Shopify.designMode) return;
  try {
    class CategoryFilterComponent extends HTMLElement {
    // Filtered-out cards are `hidden` so matching cards pack together with no gaps.
    // But if a filter matches none of the currently-loaded cards, the page collapses to
    // zero scrollable height, which stops the grid's own infinite-scroll trigger from
    // ever firing to fetch more pages — so while that's true, force extra scroll room
    // on the grid until a match shows up (removed again the moment one does).
    static applyFilter(grid) {
      const value = grid.dataset.categoryFilter || 'all';
      const sub = grid.dataset.subFilter || 'all';
      const themes = (grid.dataset.themeFilter || '').split(',').filter(Boolean);
      const types = (grid.dataset.typeFilter || '').split(',').filter(Boolean);
      const browsing = themes.length > 0 || types.length > 0;
      grid.querySelectorAll('li[data-category]').forEach((item) => {
        item.hidden =
          (value !== 'all' && !item.dataset.category.split(' ').includes(value)) ||
          (value !== 'all' && sub !== 'all' && item.dataset.subtype !== sub) ||
          (themes.length > 0 && !themes.includes(item.dataset.theme)) ||
          (types.length > 0 && !types.includes(item.dataset.type));
      });

      const productGrid = grid.querySelector('.product-grid');
      if (!productGrid) return;
      const hasMatch = grid.querySelector('li[data-category]:not([hidden])');
      productGrid.style.minHeight = (value !== 'all' || browsing) && !hasMatch ? '220vh' : '';
    }

    connectedCallback() {
      this.buttons = [...this.querySelectorAll('.category-filter__button:not(.category-filter__sub)')];
      this.subButtons = [...this.querySelectorAll('.category-filter__sub')];
      this.grid = document.querySelector(`[section-id="${this.dataset.targetSection}"]`);
      if (!this.buttons.length || !this.grid) return;

      this.buttons.forEach((button) => {
        button.addEventListener('click', () => {
          const current = this.grid.dataset.categoryFilter || 'all';
          const next = current === button.dataset.category ? 'all' : button.dataset.category;
          this.grid.dataset.categoryFilter = next;
          this.grid.dataset.subFilter = 'all';

          document
            .querySelectorAll(`category-filter-component[data-target-section="${this.dataset.targetSection}"]`)
            .forEach((instance) => instance.updateButtons(next));

          CategoryFilterComponent.applyFilter(this.grid);
        });
      });

      if (this.dataset.context) {
        this.grid.dataset.categoryFilter = this.dataset.context;
      }

      this.subButtons.forEach((button) => {
        button.addEventListener('click', () => {
          const current = this.grid.dataset.subFilter || 'all';
          this.grid.dataset.subFilter = current === button.dataset.subtype ? 'all' : button.dataset.subtype;
          document
            .querySelectorAll(`category-filter-component[data-target-section="${this.dataset.targetSection}"]`)
            .forEach((instance) => instance.updateButtons(this.grid.dataset.categoryFilter || 'all'));
          CategoryFilterComponent.applyFilter(this.grid);
        });
      });

      this.updateButtons(this.grid.dataset.categoryFilter || 'all');
      CategoryFilterComponent.applyFilter(this.grid);

      this.observer = new MutationObserver(() => CategoryFilterComponent.applyFilter(this.grid));
      this.observer.observe(this.grid, { childList: true, subtree: true });
    }

    disconnectedCallback() {
      this.observer?.disconnect();
    }

    updateButtons(active) {
      this.buttons.forEach((button) => {
        const isActive = button.dataset.category === active;
        const isDimmed = active !== 'all' && !isActive;
        button.classList.toggle('is-active', isActive);
        button.classList.toggle('is-dimmed', isDimmed);
        button.setAttribute('aria-pressed', isActive);
      });

      const sub = this.grid.dataset.subFilter || 'all';
      this.subButtons.forEach((button) => {
        const show = button.dataset.parent === active;
        const isActive = show && button.dataset.subtype === sub;
        button.hidden = !show;
        button.classList.toggle('is-active', isActive);
        button.classList.toggle('is-dimmed', show && sub !== 'all' && !isActive);
        button.setAttribute('aria-pressed', isActive);
      });
    }
  }

  if (!customElements.get('category-filter-component')) {
    customElements.define('category-filter-component', CategoryFilterComponent);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-media-gallery-content"] && !Shopify.designMode) return;
  try {
    // Click the pinned art to see it full screen; click anywhere (or press Escape) to close.
  class PinnedArtZoom extends HTMLElement {
    connectedCallback() {
      const button = this.querySelector('button');
      const dialog = this.querySelector('dialog');
      const image = this.querySelector('.pinned-art-dialog__image');
      if (!button || !dialog || !image) return;

      button.addEventListener('click', () => {
        if (!image.getAttribute('src')) image.src = image.dataset.src;
        dialog.showModal();
      });
      dialog.addEventListener('click', () => dialog.close());
    }
  }

  if (!customElements.get('pinned-art-zoom')) {
    customElements.define('pinned-art-zoom', PinnedArtZoom);
  }
  } catch(e) { console.error(e); }
})();

})();
